import { LOCALE_ID } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { provideHttpClient } from "@angular/common/http";
import { DecimalPipe, registerLocaleData } from "@angular/common";
import localeSe from "@angular/common/locales/sv";
import {
  MissingTranslationHandler,
  provideTranslateService,
} from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  IHotjarSettings,
  NGX_HOTJAR_SETTINGS_TOKEN,
  NgxHotjarService,
} from "ngx-hotjar";

import { AppComponent } from "./components/app.component";
import { routes } from "./app.routes";
import { environment } from "./environments/environment";
import { BrandService } from "./services/brand.service";
import { HotjarService } from "./services/hotjar.service";
import { FallbackMissingTranslationHandler } from "./fallbackMissingTranslationsHandler";
import { provideHotjarRouter } from "./modules/patched-hotjar.module";
import {
  EcomProductArrayPipe,
  EcomProductPipe,
} from "./pipes/ecom-product.pipe";
import { FilterDealerPipe } from "./pipes/filter-dealer.pipe";
import { GoogleMapsLatLngLitPipe } from "./pipes/google-maps-lat-lng-lit.pipe";
import { MediaPipe } from "./pipes/media.pipe";
import { TagPipe } from "./pipes/tag.pipe";

registerLocaleData(localeSe);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
    ),
    provideHttpClient(),
    provideTranslateService({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: FallbackMissingTranslationHandler,
      },
      lang: "se",
    }),
    ...provideTranslateHttpLoader(),
    { provide: LOCALE_ID, useValue: "sv-SE" },
    {
      provide: NGX_HOTJAR_SETTINGS_TOKEN,
      useValue: {
        trackingCode: environment.hotjarId,
      } satisfies IHotjarSettings,
    },
    { provide: NgxHotjarService, useExisting: HotjarService },
    {
      provide: "googleTagManagerId",
      useFactory: (brandService: BrandService) => {
        const brandFromURL = brandService.getBrandFromURL();
        if (brandService.validateBrand(brandFromURL)) {
          return environment.gtmKeys[brandFromURL];
        }
        return environment.gtmKeys.default;
      },
      deps: [BrandService],
    },
    ...provideHotjarRouter(),
    // Pipes provided at root level for constructor injection in components and services
    DecimalPipe,
    EcomProductPipe,
    EcomProductArrayPipe,
    FilterDealerPipe,
    GoogleMapsLatLngLitPipe,
    MediaPipe,
    TagPipe,
  ],
}).catch((err) => console.error(err));
